/** Salon interior photography for the print menu back cover. PLACEHOLDER — swap for your own interior shots. */

export type BackCoverInteriorPhoto = {
  src: string
  alt: string
}

export const backCoverInteriorPhotos: readonly BackCoverInteriorPhoto[] = [
  {
    src: '/interior/1.jpg',
    alt: 'Bright, clean nail salon interior with manicure stations',
  },
  {
    src: '/interior/2.jpg',
    alt: 'Salon seating and soft lighting in the salon',
  },
  {
    src: '/interior/3.jpg',
    alt: 'Manicure workspace with organized tools and products',
  },
  {
    src: '/interior/4.jpg',
    alt: 'Welcoming reception area of the nail salon',
  },
  {
    src: '/interior/5.jpg',
    alt: 'Calm salon atmosphere with guest-ready stations',
  },
]

export const backCoverThanksMessage =
  'Thank you for stopping by — we are grateful you chose our salon and hope to see you again soon.'
